var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20.48,
    viewBox: "0 0 18 20.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bin_484611",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29161",
    "data-name": "Group 29161",
    transform: "translate(32.255 5.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29160",
    "data-name": "Group 29160",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39881",
    "data-name": "Path 39881",
    d: "M62.2,150l1.062,12.9a1.812,1.812,0,0,0,1.791,1.659h9.784a1.812,1.812,0,0,0,1.791-1.659L77.7,150Zm4.747,12.143a.6.6,0,0,1-.6-.565l-.6-9.73a.6.6,0,0,1,.561-.64.592.592,0,0,1,.636.564l.6,9.73A.6.6,0,0,1,66.952,162.143Zm3.6-.6a.6.6,0,1,1-1.2,0v-9.73a.6.6,0,1,1,1.2,0Zm3.6-9.693-.6,9.73a.6.6,0,1,1-1.2-.075l.6-9.73a.611.611,0,0,1,.636-.564A.6.6,0,0,1,74.146,151.847Z",
    transform: "translate(-62.205 -150)",
    fill: "#ed1c24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29163",
    "data-name": "Group 29163",
    transform: "translate(31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29162",
    "data-name": "Group 29162",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39882",
    "data-name": "Path 39882",
    d: "M47.8,2.413H44.2v-.6A1.807,1.807,0,0,0,42.4,0H37.6a1.807,1.807,0,0,0-1.8,1.809v.6H32.2a1.206,1.206,0,0,0,0,2.413H47.8a1.206,1.206,0,0,0,0-2.413Zm-4.8,0H37v-.6a.6.6,0,0,1,.6-.6h4.8a.6.6,0,0,1,.6.6Z",
    transform: "translate(-31)",
    fill: "#ed1c24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin_icon.5169ca033387988c481653be766394fd.svg";
export { ForwardRef as ReactComponent };